import { render, staticRenderFns } from "./LedgerBank.vue?vue&type=template&id=5a19137d"
import script from "./LedgerBank.vue?vue&type=script&lang=js"
export * from "./LedgerBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports